export const purchasesZh = {
  title: '采购管理',
  create: '新建采购单',
  loading: '加载中...',
  emptyTitle: '暂无采购单',
  emptyDesc: '您还没有创建采购单',
  emptyAction: '创建第一个采购单',
  columns: {
    number: '采购单号',
    title: '标题',
    amount: '金额',
    status: '状态',
    createdAt: '创建时间',
    actions: '操作',
  },
  actions: {
    view: '查看',
  },
  status: {
    DRAFT: '草稿',
    PENDING: '审批中',
    APPROVED: '已批准',
    RECEIVED: '已验收',
    REJECTED: '已拒绝',
  },
};

export type PurchasesTranslations = typeof purchasesZh;
